<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-else>
            <v-row>
                <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
                    <div class="title_page ma-3">
                        <h4 class="breadcrumb_title_page">แก้ไขสินค้าเข้าคลัง</h4>
                        <v-breadcrumbs :items="sub_menu">
                            <template v-slot:divider>
                                <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>
                </v-col>
                <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
                    <div class="title_page ma-3">
                        <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()"
                            large>ย้อนกลับ</v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-card elevation="4" style="border-radius: 15px;">
                <v-card-text>
                    <div class="mt-3 pa-4">
                        <v-form ref="setting" @submit.prevent="saveProduct()">
                            <v-row>
                                <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="8">
                                    <div class="d-flex">
                                        <div class="title_form_main">
                                            <div class="logo_timeline">
                                                <img src="@/assets/arin_assets/ordericon.png">
                                            </div>
                                        </div>
                                        <div class="header-content py-1 pl-5 pr-5 text-center">
                                            <div class="content-font">ข้อมูลใบสั่งซื้อ</div>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="4">
                                </v-col>
                               
                                <v-col  xs="12" sm="6" md="6" lg="3" xl="3" cols="6">
                                    <v-form-group>
                                        <label class="label_form_text">เลขที่ใบอ้างอิง/ No. </label>
                                        <v-text-field type="text" class="input-radius" label="เลขที่ใบอ้างอิง/ No." disabled v-model="order.order_code"
                                            prepend-inner-icon="mdi-file-document" color="#D6BFAF" single-line outlined
                                            dense></v-text-field>
                                    </v-form-group>
                                </v-col>
                              
                                <v-col  xs="12" sm="6" md="6" lg="3" xl="3" cols="6">
                                    <v-form-group>
                                        <label class="label_form_text">เลขที่ใบเสร็จ/ใบ CN <span
                                                class="required--text">*</span></label>
                                       <v-text-field v-if="order.receipt_no !=null" color="#D6BFAF" class="input-radius" v-model="order.receipt_no"
                                            prepend-inner-icon="mdi-file-document" hide-details="auto" single-line :rules="[v => !!v || 'กรุณาป้อนข้อมูล']"
                                            placeholder="เลขที่ใบเสร็จ/ใบ CN" outlined dense required></v-text-field>
                                        <v-text-field v-else color="#D6BFAF" class="input-radius" v-model="order.receipt_no"
                                            prepend-inner-icon="mdi-file-document" hide-details="auto" single-line @click="order.receipt_no = ''"
                                            placeholder="เลขที่ใบเสร็จ/ใบ CN" outlined dense ></v-text-field>
                                    </v-form-group>
                                </v-col>
                                <v-col  xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ภาษีการซื้อ <span
                                                class="required--text">*</span></label>
                                        <v-radio-group row v-model="order.vat_type" @change="sumTotal()">
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ภาษีรวมใน"
                                                color="#D6BFAF" :value="0"></v-radio>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ภาษีแยกนอก"
                                                color="#D6BFAF" :value="1"></v-radio>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ไม่มีภาษี"
                                                color="#D6BFAF" :value="2"></v-radio>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ภาษีเป็น 0"
                                                color="#D6BFAF" :value="3"></v-radio>
                                        </v-radio-group>
                                    </v-form-group>
                                </v-col>
                                <v-col  xs="12" sm="6" md="3" lg="3" xl="3" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ชื่อ บริษัท/Supplier Name <span
                                                class="required--text">*</span></label>
                                        <v-text-field color="#D6BFAF" class="input-radius" disabled
                                            placeholder="ชื่อ บริษัท/Supplier Name" hide-details="auto" single-line outlined v-model="order.supplier_name"
                                            dense></v-text-field>
                                    </v-form-group>
                                </v-col>
                                <v-col  xs="12" sm="6" md="3" lg="3" xl="3" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">วันที่ใบเสร็จ <span
                                                class="required--text">*</span></label>
                                        <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false"
                                            transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field class="input-radius" color="#D6BFAF" v-model="order.receipt_date" label=""
                                                    prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                                                    outlined dense></v-text-field>
                                            </template>
                                            <v-date-picker locale="TH" color="#D6BFAF"  :min="date_exp" v-model="order.receipt_date"
                                                dense  no-title scrollabl></v-date-picker>
                                        </v-menu>
                                    </v-form-group>


                                    <!-- <v-form-group>
                                        <label class="label_form_text">วันที่ใบเสร็จ <span
                                                class="required--text">*</span></label>
                                        <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false"
                                            transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field class="input-radius" color="#D6BFAF" v-model="receipt_date"
                                                    label="" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                                                    v-on="on" outlined dense></v-text-field>
                                            </template>
                                            <v-date-picker locale="TH" color="#D6BFAF" v-model="dateEN" :min="minDate"
                                            no-title scrollabl></v-date-picker>
                                        </v-menu>
                                    </v-form-group> -->
                                </v-col>
                              
                            </v-row>
                            <v-row>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="d-flex">
                                        <div class="title_form_main">
                                            <div class="logo_timeline">
                                                <img src="@/assets/arin_assets/cycle.png">
                                            </div>
                                        </div>
                                        <div class="header-content py-1 pl-5 pr-5 text-center">
                                            <div class="content-font">รายการสินค้า</div>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col xs="12" sm="6" md="9" lg="9" xl="9" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">สินค้า <span class="required--text">*</span></label>
                                        <v-autocomplete color="#D6BFAF" class="input-radius" :items="product_list"
                                            item-text="name" item-value="id" hide-details="auto" v-model="product_id" @change="getUnit_list()"
                                            placeholder="กรุณาเลือกสินค้า" single-line outlined
                                            :rules="[v => product.length > 0 || 'กรุณาเลือกข้อมูล']" dense></v-autocomplete>
                                    </v-form-group>
                                </v-col>
                                <v-col xs="12" sm="6" md="3" lg="3" xl="3" cols="12">
                                    <label class="label_form_text">หน่วยนับ <span class="required--text">*</span></label>
                                    <v-autocomplete class="input-radius" color="#D6BFAF" :items="unit_list" @change="addProduct()"
                                        :rules="[v => product.length > 0 || 'กรุณาเลือกข้อมูล']" item-text="unit_name" item-value="unit_id" v-model="unit_id"
                                        placeholder="กรุณาเลือกหน่วยนับ" hide-details="auto" single-line outlined dense />
                                </v-col>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <v-simple-table fixed-header height="410px">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th style="font-size:14px;" class="text-center">ลำดับ</th>
                                                    <th style="font-size:14px;">ล๊อต</th>
                                                    <th style="font-size:14px;">รายการสินค้า</th>
                                                    <th style="font-size:14px;">วันที่หมดอายุ</th>
                                                    <th style="font-size:14px;" class="text-center">หน่วยนับ</th>
                                                    <th style="font-size:14px;" class="">จำนวนที่ได้รับ</th>
                                                    <th style="font-size:14px;" class="">ราคาต่อหน่วย</th>
                                                    <th style="font-size:14px;" class="">ส่วนลด (บาท)</th>
                                                    <th style="font-size:14px;" class="">ส่วนลด (%)</th>
                                                    <th style="font-size:14px;" class="text-right">ราคารวม</th>
                                                    <th style="font-size:14px;" class="text-center">ลบ</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, i) in product" :key="item.id">
                                                    <td class="text-center hidden_line">{{ i+1 }}</td>
                                                    <td class="hidden_line">
                                                        <v-text-field v-if="item.id == 0" class="input-radius" type="text" min="0"
                                                            hide-details="auto" label="ล๊อต" v-model="item.lot_no" color="#D6BFAF"
                                                            placeholder="ล๊อต"  @change="sumTotal(i)"
                                                            :rules="[v => !!v || 'กรุณากรอกข้อมูล']" single-line outlined
                                                            dense required></v-text-field>
                                                             <span v-else>
                                                          {{item.lot_no != null ? item.lot_no : '-'}}
                                                         </span>
                                                    </td>
                                                    <td class="hidden_line">{{ item.product_name }}</td>
                                                    <td class="hidden_line">
                                                        <v-menu ref="menu_date_exp" :v-model="false"
                                                            :close-on-content-click="false" transition="scale-transition"
                                                            offset-y min-width="auto">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-text-field class="input-radius" color="#D6BFAF"
                                                                    v-model="item.date_expired" prepend-inner-icon="mdi-calendar"
                                                                    readonly v-bind="attrs" v-on="on" single-line
                                                                    hide-details="auto" outlined dense></v-text-field>
                                                            </template>
                                                            <v-date-picker v-model="item.date_expired" :min="date_exp" @change="sumTotal(i)" color="#D6BFAF"
                                                                dense  no-title scrollabl></v-date-picker>
                                                        </v-menu>
                                                    </td>
                                                    <td class="text-center hidden_line">{{ item.unit_name }}</td>
                                                    <td class="text-center hidden_line">
                                                        <v-text-field class="input-radius" type="number" min="0" @change="sumTotal(i)"
                                                            hide-details="auto" label="จำนวนที่ได้รับ" v-model="item.quantity"
                                                            color="#D6BFAF" @keypress="isOnlyNumber($event)"
                                                            placeholder="จำนวนที่ได้รับ"
                                                            :rules="[v => !!v || 'กรุณากรอกข้อมูล']" single-line outlined
                                                            dense required></v-text-field>
                                                    </td>
                                                    <td class="text-center hidden_line">
                                                        <v-text-field class="input-radius" type="number" min="0"
                                                            hide-details="auto" label="ราคาต่อหน่วย" v-model="item.cost"
                                                            color="#D6BFAF" @keypress="isOnlyNumber($event)"
                                                            placeholder="ราคาต่อหน่วย" @change="sumTotal(i)"
                                                            :rules="[v => !!v || 'กรุณากรอกข้อมูล']" single-line outlined
                                                            dense required></v-text-field>
                                                    </td>
                                                    <td class="text-center hidden_line">
                                                        <v-text-field class="input-radius" type="number" min="0"
                                                            hide-details="auto" label="ส่วนลด (บาท)" v-model="item.discount_amount"
                                                            color="#D6BFAF" @keypress="isOnlyNumber($event)"
                                                            placeholder="ส่วนลด (บาท)" @change="sumTotal(i)"
                                                            single-line outlined dense></v-text-field>
                                                    </td>
                                                    <td class="text-center hidden_line">
                                                        <v-text-field class="input-radius" type="number" min="0" max="100"
                                                            hide-details="auto" label="ส่วนลด (%)" v-model="item.discount_percent"
                                                            color="#D6BFAF" @keypress="isOnlyNumber($event)"
                                                            placeholder="ส่วนลด (%)" @change="sumTotal(i)"
                                                            single-line outlined dense></v-text-field>
                                                    </td>
                                                    <td class="text-right hidden_line">{{ item.price }}</td>
                                                    <td class="text-center hidden_line">
                                                        <v-btn elevation="4" class="ma-2" outlined color="error"
                                                            title="ลบข้อมูล" style="border-radius:10px" @click="deleteProduct(i)">
                                                            <v-icon>mdi-trash-can-outline</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-divider></v-divider>
                                </v-col>
                                <v-row>
                                    <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <h3>รวม</h3>
                                            <h3>{{formatPrice(total)}}</h3>
                                        </div>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                        <v-row>
                                            <v-col cols="6">
                                                <p style="font-size:16px;">ส่วนลดท้ายบิล</p>
                                            </v-col>
                                            <v-col cols="6"><v-text-field type="text" v-model="discount" color="#D6BFAF"
                                                    style="width: 50%;float: right;" @keypress="isNumber($event, telephone)"
                                                    @paste="isPaste($event)" single-line outlined @change="sumTotal()"
                                                    dense></v-text-field></v-col>
                                            <v-col cols="12"> <v-divider></v-divider></v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <h3>ราคาสินค้าไม่รวมภาษี</h3>
                                            <h3>{{formatPrice(total_dis)}}</h3>
                                        </div>
                                    </v-col>
                                    <v-col v-if="vat != null" xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                                    <v-col v-if="vat != null" xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <h3>ภาษีมูลค่าเพิ่ม 7%</h3>
                                            <h3>{{formatPrice(vat)}}</h3>
                                        </div>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <h3>จำนวนเงินทั้งสิ้นรวมภาษี</h3>
                                            <h3>{{formatPrice(net)}}</h3>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="title_page ma-3" style="justify-content:center;">
                                        <v-btn type="submit" class="btn_add_data_submit" elevation="4" large>บันทึก</v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-form>
                    </div>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import { isTelephone, taxNumber, validateEmail, onPaste, minDate, formatPrice } from "@/js/handler";
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_inventory_list",
    data() {
        return {
            loading_page: false,
            search: '',
            tab_id: null,
            inventory_remove: false,
            price_new: false,
            dateRangeText: null,
            menu_date: false,
            menu_date_exp: false,
            date_exp: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateEN: '',
            dateEXP: '',
            start_date: this.min_date(),
            footer_Props: {
                'items-per-page-text': 'รายการต่อหน้า'
            },
            sub_menu: [
                {
                    text: 'คลังสินค้า',
                    disabled: false,
                },
                {
                    text: 'ระบบ POS',
                    disabled: false,
                },
                {
                    text: 'คลังสินค้า',
                    disabled: false,
                },
                {
                    text: 'เพิ่มสินค้าเข้าคลัง',
                    disabled: false,
                    href: '#',
                },
            ],
            headers: [
                {
                    text: 'รหัสสินค้า',
                    value: '',
                    fixed: true,
                },
                {
                    text: 'ชื่อสินค้า',
                    value: '',
                    fixed: true,
                },
                {
                    text: 'จำนวน',
                    value: '',
                    fixed: true,
                },
                {
                    text: 'หน่วยนับ',
                    value: 'product_code',
                    fixed: true,
                },
                {
                    text: 'จัดการ',
                    value: '',
                    fixed: true,
                    sortable: false,
                },
            ],
            none: null,
            order: {},
            product: [],
            product_data: [],
            product_new: [],
            product_del: [],
            product_list: [],
            unit_list: [],
            data_list: [],
            data:{},

            //ตัวแปร
            product_id: null,
            unit_id: null,
            total:0,
            total_dis:0,
            net:0,
            vat:0,
            discount:0,
        }
    },
    methods: {
        formatPrice(number){
            return formatPrice(number)
        },
        link(link) {
            window.location.href = link;
        },
        inventory_remove_dialog() {
            this.inventory_remove = true;
        },
        price_new_dialog() {
            this.price_new = true;
        },
        tabs(number) {
            this.tab_id = number
            if (number === 1) {
                this.data_list = [
                    {
                        id: 1,
                        promotion_code: 'ANB0015',
                        promotion_name: 'inj.GLUCOSE 20 CC for *INJection* 10.-',
                        qty: '49',
                        unit_name: 'Ampule',
                    },
                    {
                        id: 2,
                        promotion_code: 'BER3029',
                        promotion_name: 'tab.CARATEN 12.5 MG.BX 100 s 1300.-',
                        qty: '49',
                        unit_name: 'แผง',
                    },
                    {
                        id: 3,
                        promotion_code: 'PRO-007',
                        promotion_name: 'wt.น้ำกลั่นปราศจากเชื้อ ANB 1000 ML. **ฝาฟ้า 55.-',
                        qty: '20',
                        unit_name: 'ขวด',
                    },
                    {
                        id: 4,
                        promotion_code: 'PRO-008',
                        promotion_name: 'ยาดม IZE JELLI BALM 7 G 29.-',
                        qty: '30',
                        unit_name: 'ขวด',
                    },
                    {
                        id: 5,
                        promotion_code: '2M1205',
                        promotion_name: 'cr.SUPIROCIN OINT 5G 95.-',
                        qty: '5',
                        unit_name: 'หลอด',
                    },
                ]
            } else if (number === 2) {
                this.data_list = [
                    {
                        id: 1,
                        promotion_code: 'BB0004',
                        promotion_name: 'Bananaboat Aloe Vera Gel 90 ml 152.-',
                        qty: '49',
                        unit_name: 'หลอด',
                        status: true,
                    },
                ]
            }
        },
        isNumber: function (evt, number) {
            return isTelephone(evt, number)
        },
        isTaxNumber: function (evt, number) {
            return taxNumber(evt, number)
        },
        isEmail: function (evt) {
            return validateEmail(evt)
        },
        isPaste: function (evt) {
            return onPaste(evt)
        },
        min_date: function () {
            return minDate()
        },
        async selectDate() {
            this.$refs.menu_date.save(this.date)
            this.menu_date = false
        },
        DateEXP_TH(value) {
            const diff = value.split('-')
            const day = diff[2]
            const month = diff[1]
            const year = parseInt(diff[0]) + 543
            const final_date = day + '/' + month + '/' + year
            return this.date_exp = final_date
        },
        diffDateTH(value) {
            const diff = value.split('-')
            const day = diff[2]
            const month = diff[1]
            const year = parseInt(diff[0]) + 543
            const final_date = day + '/' + month + '/' + year
            return this.date = final_date
        },
        diffDateEN() {
            const diff = this.date.split('-')
            const year = parseInt(diff[2]) - 543
            const month = diff[1]
            const day = diff[0]
            return year + '-' + month + '-' + day
        },
        computed: {
            dateRangeText() {
                return this.dates.join(' ~ ')
            },
        },
        getOrder(){
            let id = this.$route.params.id;
             const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
        HTTP_ARIN.get('/pos/import/'+ id, config).then((res) => {
            if (res.data.successful === true) {
            this.order = res.data.data.import;
            this.discount = parseFloat(res.data.data.import.discount);
            this.product = res.data.data.import_list;
            this.product = this.product.map(item => {
                return {
                    ...item,
                    date_expired: item.date_expired.split(' ')[0],
                    discount_amount: item.discount_amount == null ? '' : item.discount_amount,
                    discount_percent: item.discount_percent == null ? '' : item.discount_percent,
                }
            })
            for(let i = 0; i < this.product.length; i++){
                this.product_data.push({
                    id: this.product[i].id,
                    date_expired: this.product[i].date_expired.split(' ')[0],
                    quantity: this.product[i].quantity,
                    cost: this.product[i].cost,
                    price: this.product[i].price,
                    discount_amount: this.product[i].discount_amount,
                    discount_percent: this.product[i].discount_percent,
                    quantity_in_unit: this.product[i].quantity_in_unit
                });
            }
            this.sumTotal();
            this.loading_page = false;
            }
        })
        },
         getProducts(){
             const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/pos/get/product', config).then((res) => {
          if (res.data.successful === true) {
            this.product_list = res.data.product;
              }
              this.loading_page = false;
      })
        },
        getUnit_list(){
             const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/pos/get/productlist/'+this.product_id, config).then((res) => {
          if (res.data.successful === true) {
            this.unit_list = res.data.product;
              }
              this.loading_page = false;
      })
        },
         addProduct(){
                  let product_check = this.product_list.find(o => o.id === this.product_id);
            let unit_check = this.unit_list.find(o => o.unit_id === this.unit_id);
            let product = this.product.find(o => o.unit_id === this.unit_id && o.product_id === this.product_id);
            if(product == null){
                 this.product.push({
                id: 0,
                product_name: product_check.name,
                unit_id: unit_check.unit_id,
                unit_name:unit_check.unit_name,
                quantity_in_unit:unit_check.quantity_in_unit,
                product_code:unit_check.product_code,
                product_id:unit_check.id,
                price:0,
                quantity: null,
                cost: null,
                discount_amount: '',
                discount_percent: '',
                index: this.product_new.length,
                lot_no: null,
                date_exp: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            })
                 this.product_new.push({
                id: product_check.id,
                product_id: unit_check.product_id,
                product_name: product_check.name,
                product_code:unit_check.product_code,
                unit_id: unit_check.unit_id,
                quantity_in_unit:unit_check.quantity_in_unit,
                quantity: null,
                price: null,
                cost: null,
                discount_amount: '',
                discount_percent: '',
                lot_no: null,
                date_expired: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            })
                
            }
        },
         deleteProduct(i){
            this.product_del.push({
                id:  this.product[i].id
            })
            let data = this.product[i];
            this.product.splice(i, 1);
          let dup = this.product_new.findIndex(item => item.unit_id === data.unit_id && item.product_name === data.product_name);
            if (dup !== -1) {
                this.product_new.splice(dup, 1);
            }
        },
          sumTotal(i = null){
            if(i != null){
                if(i <= (this.product_data.length - 1)){
                    this.product_data[i].quantity = parseInt(this.product[i].quantity)
                    this.product_data[i].cost = parseInt(this.product[i].cost)
                    const basePrice = parseFloat(this.product[i].cost == null || this.product[i].cost === '' ? 0 : this.product[i].cost) * parseFloat(this.product[i].quantity == null || this.product[i].quantity === '' ? 0 : this.product[i].quantity)
                    const discountAmount = parseFloat(this.product[i].discount_amount == null || this.product[i].discount_amount === '' ? 0 : this.product[i].discount_amount)
                    const discountPercent = parseFloat(this.product[i].discount_percent == null || this.product[i].discount_percent === '' ? 0 : this.product[i].discount_percent)
                    const percentAmount = basePrice * (discountPercent / 100)
                    const lineTotal = Math.max(basePrice - percentAmount - discountAmount, 0)
                    this.product_data[i].price = lineTotal
                    this.product_data[i].date_expired = this.product[i].date_expired
                    this.product_data[i].discount_amount = discountAmount
                    this.product_data[i].discount_percent = discountPercent
                }
  if(this.product[i].cost != null && this.product[i].quantity != null){
                 const basePrice = parseFloat(this.product[i].cost == null || this.product[i].cost === '' ? 0 : this.product[i].cost) * parseFloat(this.product[i].quantity == null || this.product[i].quantity === '' ? 0 : this.product[i].quantity)
                 const discountAmount = parseFloat(this.product[i].discount_amount == null || this.product[i].discount_amount === '' ? 0 : this.product[i].discount_amount)
                 const discountPercent = parseFloat(this.product[i].discount_percent == null || this.product[i].discount_percent === '' ? 0 : this.product[i].discount_percent)
                 const percentAmount = basePrice * (discountPercent / 100)
                 this.product[i].price = Math.max(basePrice - percentAmount - discountAmount, 0)
                 let index =  this.product[i].index;
                this.product_new[index].price = this.product[i].price
                this.product_new[index].cost = parseInt(this.product[i].cost)
                this.product_new[index].quantity = parseInt(this.product[i].quantity)
                this.product_new[index].discount_amount = discountAmount
                this.product_new[index].discount_percent = discountPercent
            }
            if(this.product[i].lot_no != null){
                this.product_new[this.product[i].index].lot_no = this.product[i].lot_no;
            }
            }
            let total = 0;
             switch(this.order.vat_type){
                            case 0 : 
                             for(let a = 0; a < this.product.length; a++){
                                 total += parseFloat(this.product[a].price);
                                 this.total = total
                                this.total_dis = ((this.total  - this.discount) * (100/107));
                                this.vat = (total - this.discount) - ((total - this.discount) * (100/107));
                                this.net = this.total_dis + this.vat;
                             }
                            break;
                             case 1 : 
                             for(let a = 0; a < this.product.length; a++){
                                 total += parseFloat(this.product[a].price);
                                 this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = this.total_dis * (7 / 100);
                                this.net = this.total_dis + this.vat;
                                }
                            break;
                             case 2 : 
                             for(let a = 0; a < this.product.length; a++){
                                total += parseFloat(this.product[a].price);
                                 this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = null;
                                this.net = this.total_dis;
                                }
                            break;
                             case 3 : 
                             for(let a = 0; a < this.product.length; a++){
                                 total += parseFloat(this.product[a].price);
                                 this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = 0;
                                this.net = this.total_dis;
                             }
                            break;
                        }
        },
        saveProduct(){
            if(this.order.receipt_no == null){
                this.order.receipt_no = ''
            }
           if(this.$refs.setting.validate() && this.order.receipt_no != ''){
                let duplicateIndices = [];
            let check_product = this.product;
            let product = [];
            check_product.forEach((element, index) => {
            // Find the index of the first occurrence of the current element
            const firstIndex = check_product.findIndex((e, i) => i !== index && e.product_id === element.product_id);
            // If a duplicate is found
            if (firstIndex !== -1) {
                // Add both the current index and the first occurrence index to the duplicateIndices array
                duplicateIndices.push(index);
            }
            });
             if(duplicateIndices.length !== 0){
                 for(let i = 0; i < duplicateIndices.length; i++){
                let index = duplicateIndices[i];
                  for(let a = 0; a < this.product.length; a++ ){
                    if(a != index){
                        if(this.product[a].product_id == this.product[index].product_id){
                            this.product[index].quantity = (parseInt(this.product[a].quantity) * parseInt(this.product[a].quantity_in_unit)) + (parseInt(this.product[index].quantity) * parseInt(this.product[index].quantity_in_unit));
                             duplicateIndices.splice(index, 1);
                              this.product.splice(a, 1);
                             i = 0;
                    }
                    }
                  }
            }
            for(let i = 0; i < this.product.length; i++){
              product.push({
                    product_code: this.product[i].product_code,
                    date_expired: this.product[i].date_expired,
                    quantity: this.product[i].quantity,
                })
            }
             }else{
                 for(let i = 0; i < this.product.length; i++){
              product.push({
                    product_code: this.product[i].product_code,
                    date_expired: this.product[i].date_expired,
                    quantity: this.product[i].quantity,
                })
            }
             }
            let product_list = [];
            let product_list_del = this.product_del;
            let product_list_new = [];
            for(let i = 0; i < this.product_data.length; i++){
                product_list.push({
                    id: this.product_data[i].id,
                    date_expired: this.product_data[i].date_expired,
                    quantity: 2,
                    cost: this.product_data[i].cost,
                    price: this.product_data[i].price,
                    discount_amount: this.product_data[i].discount_amount == null || this.product_data[i].discount_amount === '' ? 0 : this.product_data[i].discount_amount,
                    discount_percent: this.product_data[i].discount_percent == null || this.product_data[i].discount_percent === '' ? 0 : this.product_data[i].discount_percent
                })
            }
            for(let i = 0; i < this.product_new.length; i++ ){
                product_list_new.push({
                    id: this.product_new[i].id,
                    product_id: this.product_new[i].product_id,
                    product_code: this.product_new[i].product_code,
                    date_expired: this.product_new[i].date_expired,
                    quantity: this.product_new[i].quantity,
                    quantity_in_unit: this.product_new[i].quantity_in_unit,
                    cost: this.product_new[i].cost,
                    price: this.product_new[i].price,
                    discount_amount: this.product_new[i].discount_amount == null || this.product_new[i].discount_amount === '' ? 0 : this.product_new[i].discount_amount,
                    discount_percent: this.product_new[i].discount_percent == null || this.product_new[i].discount_percent === '' ? 0 : this.product_new[i].discount_percent,
                    unit_id: this.product_new[i].unit_id,
                    lot_no: this.product_new[i].lot_no
                })
            }
             this.data = {
                order_code: this.order.order_code,
                order_id: this.order.order_id,
                receipt_no: this.order.receipt_no,
                supplier_id: this.order.supplier_id,
                supplier_name: this.order.supplier_name,
                receipt_date: this.order.receipt_date,
                vat_type: this.order.vat_type,
                import_type: 0,
                is_credit: 0,
                discount: this.discount == null || this.discount == '' ? 0 : this.discount,
                total: this.total,
                product_list: this.product_data,
                product_list_del: product_list_del,
                product_list_new:product_list_new,
                product_list_update: product
            } 
            let data = this.data;
             this.editImport(data);
           }
        },
        editImport(data){
             let id = this.$route.params.id;
             const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
                      // ส่งไปเพิ่ม
                HTTP_ARIN.post('/pos/import/edit/'+id, data, config)
                    .then((res) => {
                    if (res.data.successful === true) {
                        let timerInterval
                        Swal.fire({
                            title: 'เสร็จสิ้น',
                            text: 'เพิ่มข้อมูลเรียบร้อยแล้ว',
                            icon: 'success',
                            timer: 2000,
                            timerProgressBar: true,
                            didOpen: () => {
                                Swal.showLoading()
                                timerInterval = setInterval(() => { }, 100)
                            },
                            willClose: () => {
                                clearInterval(timerInterval)
                                setTimeout(function () {
                                    window.location.href = '/arin/pos/historyimportinventory';
                                });
                            }
                        })
                    } else {
                        Swal.fire({
                        title: 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง!',
                        icon: 'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: `ตกลง`,
                        denyButtonText: `ยกเลิก`,
                        })
                    }
                })
        }
    },
    mounted() {
        this.getOrder();
        this.getProducts();
        this.getUnit_list();
        this.tabs(1)
    }
}
</script>

<style scoped>
.input-radius {
    border-radius: 10px;
}

.v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 4px !important;
}
</style>
